import React, { useState } from "react";
import { ShoppingBag } from "lucide-react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { SalesTable } from "./SalesTable";
import { InvoicePreviewModal } from "./InvoicePreviewModal";

export const SalesView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  consolidatedSales,
  parties,
  setSelReq,
  setSelSale,
  setSaleOpen,
  onExport,
  isExporting
}) => {
  const [previewSale, setPreviewSale] = useState(null);

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        parties={parties}
        partyLabel="Projects/Customers"
        showStatusFilter={false}
        showVendorFilter={false}
        showCategoryFilter={false}
        showCustomerFilter={true}
        onAddItemClick={() => {
          setSelSale(null);
          setSaleOpen(true);
        }}
        buttonLabel="Sale"
        onExport={onExport}
        isExporting={isExporting}
      />
      <SalesTable
        sales={consolidatedSales}
        onView={(s) => {
          if (s.recordType === 'material_request') {
            setSelReq(s.originalRequest || s);
          } else {
            setPreviewSale(s);
          }
        }}
        onEdit={(s) => {
          if (s.recordType === 'sale') {
            setSelSale(s);
            setSaleOpen(true);
          }
        }}
      />
      {consolidatedSales.length === 0 && (
        <div className="card p-12 flex flex-col items-center justify-center bg-white shadow-sm border border-slate-100 rounded-2xl">
          <div className="w-16 h-16 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-4">
            <ShoppingBag size={32} />
          </div>
          <h2 className="text-xl font-bold text-brand-dark mb-1">Sales Log</h2>
          <p className="text-slate-500 text-sm">Sales and Project Dispatches will appear here.</p>
        </div>
      )}
      <div className="hidden debug-data" data-sales-count={consolidatedSales.length}></div>

      <InvoicePreviewModal
        isOpen={!!previewSale}
        onClose={() => setPreviewSale(null)}
        sale={previewSale}
      />
    </div>
  );
};

